import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import { TrafegoPagoService, TRAFEGO_PAGO_AUTH_MESSAGE } from '../services/TrafegoPagoService';
import { useCelular } from '../hooks/useCelular';
import './GoogleCalendarCallbackPage.css';

export const TRAFEGO_PAGO_STATE_KEY = 'lemeai:meta-ads-oauth-state';

const TrafegoPagoCallbackPage: React.FC = () => {
    const celular = useCelular();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Conectando sua conta de anúncios...');

    useEffect(() => {
        const avisarAbridor = (success: boolean, mensagem?: string) =>
            window.opener?.postMessage(
                { type: TRAFEGO_PAGO_AUTH_MESSAGE, success, mensagem },
                window.location.origin
            );

        const run = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');
            const errorParam = params.get('error');

            const esperado = sessionStorage.getItem(TRAFEGO_PAGO_STATE_KEY);
            sessionStorage.removeItem(TRAFEGO_PAGO_STATE_KEY);

            if (errorParam || !code) {
                setStatus('error');
                setMessage('A conexão com a conta de anúncios foi cancelada ou falhou.');
                avisarAbridor(false);
                return;
            }

            if (!state || !esperado || state !== esperado) {
                setStatus('error');
                setMessage('Requisição de conexão inválida. Tente novamente pela tela de conexões.');
                avisarAbridor(false);
                return;
            }

            try {
                const resultado = await TrafegoPagoService.conectarConta(code);

                if (resultado.sucesso) {
                    const qtd = resultado.dados?.length ?? 0;
                    setStatus('success');
                    setMessage(`${qtd} conta(s) de anúncio conectada(s).`);
                    avisarAbridor(true, `${qtd} conta(s) de anúncio conectada(s).`);
                } else {
                    setStatus('error');
                    setMessage(resultado.mensagem || 'Não foi possível conectar a conta de anúncios.');
                    avisarAbridor(false, resultado.mensagem);
                }
            } catch {
                setStatus('error');
                setMessage('Erro de conexão ao tentar autenticar com a Meta.');
                avisarAbridor(false);
            } finally {
                setTimeout(() => window.close(), 1800);
            }
        };

        run();
    }, []);

    return (
        <div className="google-callback-container">
            <div className="google-callback-card">
                {status === 'loading' && <FaSpinner className="spin google-callback-icon" />}
                {status === 'success' && <FaCheckCircle className="google-callback-icon success" />}
                {status === 'error' && <FaTimesCircle className="google-callback-icon error" />}
                <p>{message}</p>
                {/* Janela aberta pelo app fecha sozinha; aba solta ou app instalado no celular
                    não fecha, então a pessoa precisa de um caminho de volta. */}
                {celular && !window.opener ? (
                    status !== 'loading' && <a className="google-callback-voltar" href="/">Voltar ao app</a>
                ) : (
                    <span className="google-callback-hint">Esta janela será fechada automaticamente.</span>
                )}
            </div>
        </div>
    );
};

export default TrafegoPagoCallbackPage;
